import { api } from '../api';
import {
  GET_MARKET_LIST,
  GET_NEWEST_MARKET_LIST
} from '../../constants/market';
import {
  GetMarketRequestType,
  GetMarketResponseType,
  NewestMarketResponseType
} from './types';
import { historySlice } from '../history';

export const marketSlice = api.injectEndpoints({
  endpoints: (build) => ({
    getMarketList: build.query<GetMarketResponseType, GetMarketRequestType>({
      query: (data) => {
        return {
          url: GET_MARKET_LIST,
          method: 'Get',
          params: data
        };
      }
    }),
    getNewestMarketList: build.query<NewestMarketResponseType, void>({
      query: () => GET_NEWEST_MARKET_LIST
    })
  }),
  overrideExisting: false
});

export const {
  useGetMarketListQuery,
  useLazyGetMarketListQuery,
  useGetNewestMarketListQuery
} = marketSlice;
